import { useMemo } from "react";
import { useAppDispatch, useRootState } from "./index";
import { bindActionCreators } from "redux";
import {
  trunkGetLoginLog,
  trunkGetLoginLogExcel,
  trunkGetWorkgroupLog,
  trunkGetWorkgroupLogExcel,
  trunkGetDocLog,
  trunkGetDocLogExcel,
} from "../store/admin/adminLog";

const useAdminContentStore = () => {
  const adminLogStore = useRootState((state) => state.adminLogStore);

  const dispatch = useAppDispatch();

  const boundGetLoginLog = useMemo(
    () => bindActionCreators(trunkGetLoginLog, dispatch),
    [dispatch]
  );
  const boundGetLoginLogExcel = useMemo(
    () => bindActionCreators(trunkGetLoginLogExcel, dispatch),
    [dispatch]
  );

  const boundGetWorkgroupLog = useMemo(
    () => bindActionCreators(trunkGetWorkgroupLog, dispatch),
    [dispatch]
  );
  const boundGetWorkgroupLogExcel = useMemo(
    () => bindActionCreators(trunkGetWorkgroupLogExcel, dispatch),
    [dispatch]
  );

  const boundGetDocLog = useMemo(
    () => bindActionCreators(trunkGetDocLog, dispatch),
    [dispatch]
  );
  const boundGetDocLogExcel = useMemo(
    () => bindActionCreators(trunkGetDocLogExcel, dispatch),
    [dispatch]
  );

  return {
    adminLogStore,
    getLoginLog: boundGetLoginLog,
    getLoginLogExcel: boundGetLoginLogExcel,
    getWorkgroupLog: boundGetWorkgroupLog,
    getWorkgroupLogExcel: boundGetWorkgroupLogExcel,
    getDocLog: boundGetDocLog,
    getDocLogExcel: boundGetDocLogExcel,
  };
};

export default useAdminContentStore;
